// Серверные даты хранятся в UTC, часто без суффикса 'Z'.
// Эти хелперы корректно приводят их к локальному времени пользователя.
export const parseServerDate = (value) => {
  if (!value) return null;
  if (typeof value === 'string' && !/(Z|[+-]\d{2}:?\d{2})$/.test(value)) {
    return new Date(value + 'Z');
  }
  return new Date(value);
};

export const formatMessageTime = (value) => {
  const d = parseServerDate(value);
  return d && !isNaN(d) ? d.toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' }) : '';
};

export const formatServerDateTime = (value) => {
  const d = parseServerDate(value);
  return d && !isNaN(d) ? d.toLocaleString('ru-RU') : '';
};

// Ж11 (TZ-6 п.7): единая зона MSK для админки и истории уведомлений
export const formatMsk = (value, withLabel = true) => {
  const d = parseServerDate(value);
  if (!d || isNaN(d)) return '';
  const s = d.toLocaleString('ru-RU', { timeZone: 'Europe/Moscow', day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' });
  return withLabel ? `${s} MSK` : s;
};

export const formatMskDate = (value) => {
  const d = parseServerDate(value);
  return d && !isNaN(d) ? d.toLocaleDateString('ru-RU', { timeZone: 'Europe/Moscow' }) : '';
};
